/*
 * Copyright (c) 2023. Haodong JU
 */

import IKUtils from 'innerken-js-utils'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import i18n from '@/i18n'
import { doc, setDoc } from 'firebase/firestore'
import { FireBaseStore } from '@/model/firebase/google-fire-base'
import { getCurrentUserId } from '@/model/dataLayer/api/SaaS/user'

export const ProductTypes = {
  software: 'software',
  hardware: 'hardware',
  serve: 'serve',
  user: 'user',
  extraDevice: 'extraDevice'
}
export const readOnlyCode = [ProductCodes.base, ProductCodes.openDevice]
export const storeType = [
  {
    id: 1,
    title: i18n.t('Tea'),
    icon: 'ice-tea.png'
  }, {
    id: 2,
    title: i18n.t('retail'),
    icon: 'supermarket.png'
  }, {
    id: 3,
    title: i18n.t('Command'),
    icon: 'dining-table.png'
  }, {
    id: 4,
    title: i18n.t('Delivery'),
    icon: 'take-away.png'
  }, {
    id: 5,
    title: i18n.t('SelfBuild'),
    icon: 'buffet.png'
  }, {
    id: 6,
    title: i18n.t('HotPot'),
    icon: 'hotpot.png'
  }, {
    id: 7,
    title: i18n.t('MalaTang'),
    icon: 'barbecue.png'
  }, {
    id: 8,
    title: i18n.t('Other'),
    icon: 'ellipsis.png'
  }
]
export const defaultSaaSOrder = {
  storeType: null,
  isChain: null,
  storeId: null,
  selectedProductList: []
}

export let currentSaaSOrder = IKUtils.deepCopy(defaultSaaSOrder)

const SaaSOrderPath = 'saasOrder'

async function saveCurrentSaaSOrder () {
  await setDoc(doc(FireBaseStore, SaaSOrderPath, await getCurrentUserId()), currentSaaSOrder)
}

export function getCurrentSaaSOrderInfo () {
  return currentSaaSOrder
}

export async function selectStoreType (typeId) {
  currentSaaSOrder.storeType = typeId
  saveCurrentSaaSOrder()
}

export async function selectIsChain (isChain) {
  currentSaaSOrder.isChain = isChain
  saveCurrentSaaSOrder()
}

export function productIsInCart (productId) {
  return currentSaaSOrder.selectedProductList.find(it => it.id === productId)
}

export async function addProduct (product) {
  const existP = productIsInCart(product.id)
  if (existP) {
    existP.count = product.count
  } else {
    currentSaaSOrder.selectedProductList.push(product)
  }
  saveCurrentSaaSOrder()
}

export async function removeProduct (product) {
  currentSaaSOrder.selectedProductList = currentSaaSOrder.selectedProductList.filter(it => it.id !== product.id)
  saveCurrentSaaSOrder()
}

export async function clearProduct (type) {
  if (type) {
    currentSaaSOrder.selectedProductList = currentSaaSOrder.selectedProductList.filter(it => it.metadata.type !== type)
  } else {
    currentSaaSOrder.selectedProductList = []
  }
  saveCurrentSaaSOrder()
}

export function resetOrder () {
  currentSaaSOrder = IKUtils.deepCopy(defaultSaaSOrder)
}
